import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({
  color,
  children,
  onClick,
  disabled,
  type = "button",
}: ButtonProps) => (
  <StyledButton
    color={color}
    onClick={onClick}
    disabled={disabled}
    type={type}
  >
    {children}
  </StyledButton>
);
